const angular = require('angular');

export default angular.module('nomasvelloDashboardApp.monthlySelling.pulsesReportRow', [])
  .directive('pulsesReportRow', function () {
    return {
      template: require('./pulsesReportRow.pug'),
      replace: true,
      restrict: 'C'
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/manager/monthlySelling/directives/pulsesReportRow/index.ts